import {ConversationMessage} from '@/types/conversationMessage';
import api from '@/api';

const CONTENT_SUBMISSION_VERSIONS_PATH = 'content_submission_versions';
const DEFAULT_INCLUDES = ['sender', 'message_attachments'];

const contentSubmissionVersionMessagesFetchers = {
  list: async (versionId: string): Promise<ConversationMessage[]> => {
    const result = await api.get(
      `${CONTENT_SUBMISSION_VERSIONS_PATH}/${versionId}/messages`,
      {
        params: {
          include: DEFAULT_INCLUDES,
        },
      }
    );
    return result.data as ConversationMessage[];
  },
};

export default contentSubmissionVersionMessagesFetchers;
